import React, { useState, useEffect } from 'react'
import { Button, Typography, Alert } from 'components'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { CodeResponseStorage } from './components/types/responses'
import { sendCodeRequest, validateCodeRequest } from 'services/forgetPassword'
import { ROUTES } from 'constants/urls'
import ReactCodeInput from 'react-code-input'

import * as S from './styles'
import { AuthLayout } from 'layouts/AuthLayout'

const { forgetPassword } = ROUTES

const ValidateCode: React.FC = () => {
  const [code, setCode] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [showInvalidCodeError, setShowInvalidCodeError] = useState<boolean>(false)
  const [resendCode, setResendCode] = useState<boolean>(false)
  const isButtonDisabled = code === '' || code.length < 6

  const email = localStorage.getItem('resetPassword')
  const emailFromStorage: CodeResponseStorage = email !== null && JSON.parse(email)

  const navigate = useNavigate()

  useEffect(() => {
    if (email === null) {
      navigate(forgetPassword.base)
    }
  }, [])

  const handleInputChange = (value: string) => {
    setShowInvalidCodeError(false)
    setCode(value)
  }

  const handleResendCode = async () => {
    await sendCodeRequest({
      ds_emai: emailFromStorage.email
    })
    toast.success('Código enviado com sucesso!')
  }

  const handleValidateCode = async (event: React.FormEvent) => {
    event.preventDefault()
    setLoading(true)
    try {
      const response = await validateCodeRequest({
        ds_cod_senh: code,
        id_usua: emailFromStorage.id_usua
      })

      const { return_code } = response

      if (return_code === 6010) {
        setShowInvalidCodeError(true)
        return
      }
      if (return_code === 6011) {
        toast.error('Código expirado. Por favor, solicite um código novamente.')
        setResendCode(true)
        return
      }

      localStorage.setItem(
        'resetPassword',
        JSON.stringify({
          ...emailFromStorage,
          code: code,
          return_chav: 'Sucesso'
        })
      )
      navigate(forgetPassword.getLink('resetPassword'))
    } catch (error) {
      toast.error('Erro no código de validação')
    } finally {
      setLoading(false)
    }
  }

  return (
    <AuthLayout>
      <form onSubmit={handleValidateCode} autoComplete="true">
        <S.FieldsWrapper>
          <Typography className="forgetTitle" design="hav-h5-text">
            Verificação
          </Typography>

          <Typography className="forgetDescription">
            Insira o código que foi enviado para e-mail:
            <br />
            <strong>{emailFromStorage.email.toLowerCase()}</strong>
            <br />
            nos campos abaixo.
          </Typography>
          {showInvalidCodeError && (
            <S.ErrorWrapper>
              <Alert
                kind="error"
                fullWidth
                title="Código incorreto."
                message="Verifique o código digitado e tente novamente."
              />
            </S.ErrorWrapper>
          )}
          <ReactCodeInput
            name="code"
            inputMode="latin"
            forceUppercase
            fields={6}
            type="text"
            onChange={handleInputChange}
            placeholder="-"
            isValid={!showInvalidCodeError}
            inputStyle={{
              height: '40px',
              width: '40px',
              borderRadius: '5px',
              border: '1px solid #BCBCBC',
              marginRight: '10px',
              textAlign: 'center'
            }}
            inputStyleInvalid={{
              border: '1px solid #FF0000',
              height: '40px',
              width: '40px',
              borderRadius: '5px',
              margin: '2.5px',
              textAlign: 'center'
            }}
          />
        </S.FieldsWrapper>
        <S.ButtonWrapper>
          <Button
            fullWidth
            content="Confirmar"
            type="submit"
            loading={loading}
            disabled={isButtonDisabled}
          />
        </S.ButtonWrapper>
        {resendCode && (
          <S.ResendCode onClick={handleResendCode}>Reenviar código</S.ResendCode>
        )}
      </form>
    </AuthLayout>
  )
}

export default ValidateCode
